import { environment } from '@/environments/environment';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from 'date-fns';
import { enUS, es, it, ja, nb, pl, pt, zhTW } from 'date-fns/locale';
import moment from 'moment';
import { CookieService } from 'ngx-shared-services';
import { WeatherStore } from '../../services/weather.store';
import { DayTileComponent } from '../day-tile/day-tile.component';

const DATE_FNS_LOCALES: Record<string, Locale> = {
  en: enUS,
  es: es,
  it: it,
  ja: ja,
  nb: nb,
  pl: pl,
  pt: pt,
  zh: zhTW,
};

@Component({
  selector: 'dr-flex-home-ui-weather-bottom',
  standalone: true,
  imports: [CommonModule, DayTileComponent],
  templateUrl: './weather-bottom.component.html',
  styleUrls: ['./weather-bottom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeatherBottomComponent {
  store = inject(WeatherStore);
  private readonly translate = inject(TranslateService);
  private readonly cookieService = inject(CookieService);

  private readonly dateFnsLocale = computed<Locale>(() => {
    const raw = this.cookieService.getI18NLocale() || environment.defaults.locale;
    const lang = raw.toLowerCase().split('-')[0];
    return DATE_FNS_LOCALES[lang] ?? enUS;
  });

  labelFor(iso: string, idx: number) {
    const today = this.translate.instant('FLEX_HOME.WEATHER_WIDGET.TODAY', {});
    if (this.store.todayIdx() === idx) return today;
    const tileDate = moment.parseZone(iso);
    return tileDate.locale(this.dateFnsLocale().code).format('dddd');
  }

  select(idx: number) {
    if (this.store.data()?.days[idx].hourly.length === 0) return;
    this.store.selectedDayIdx.set(idx);
  }
}
